import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MatCheckboxChange, MAT_BOTTOM_SHEET_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { BottomSheetHelperService } from '../../services/bottomSheetHelper.service';
import { CoreCOMService } from '../../services/com.service';
import { ItemTagHelperService } from '../../services/itemTagHelper.service';
import { CoreLogService } from '../../services/log.service';
import { UserHelperService } from '../../services/userHelper.service';
import { LocalKeys, StorageHive } from '../../services/valueStorage.service';
import { ItemTagStatusType, ItemTagType, SortDirection } from '../../shared/contentTypes';
import { ItemTagViewModel } from '../../shared/models';
import { SortOption } from '../../shared/models/sort.model';
import { PagingHelper } from '../../shared/pagingHelper';
import { LoginDialogComponent } from '../logindialog/logindialog.component';

@Component({
  selector: 'ya-filtertagdialog',
  templateUrl: './filterTagDialog.component.html',
  styleUrls: ['./filterTagDialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterTagDialogComponent implements OnInit {

  public itemTagStatus = ItemTagStatusType;
  public tagType = ItemTagType;
  public saveToUserData: boolean = false;
  public showGradient: boolean = true;

  constructor(public bottomSheetRef: MatBottomSheetRef<FilterTagDialogComponent>
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _itemTagHelperService: ItemTagHelperService
    , public _userHelperService: UserHelperService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , @Inject(MAT_BOTTOM_SHEET_DATA) public dialogData: any) {

  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("FilterTagDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.PushChanges();
  }

  public setTagFilter() {
    const me = this;
    me._itemTagHelperService.saveItemTagsOnStorage(me.dialogData.itemTags);
    if (me.saveToUserData) {
      me._itemTagHelperService.saveUserTags(me.dialogData.itemTags);
    }
    me.bottomSheetRef.dismiss(me.dialogData.itemTags);
  }

  public resetTagFilter() {
    const me = this;
    me._itemTagHelperService.resetItemTagsOnStorage();
    if (me.saveToUserData) {
      me._itemTagHelperService.saveUserTags(me.dialogData.itemTags);
    }
    me.bottomSheetRef.dismiss(me.dialogData.itemTags);
  }

  public setItemTagStatus(itemTag: ItemTagViewModel, tagStatus: ItemTagStatusType) {
    const me = this;
    if (itemTag.itemTagStatus === tagStatus) {
      itemTag.itemTagStatus = me.itemTagStatus.neutral;
    } else {
      itemTag.itemTagStatus = tagStatus;
    }
    me.PushChanges();
  }

  public svgSanitizer(svg: string) {
    const me = this;
    return me._itemTagHelperService.svgSanitizer(svg);
  }

  /**check the offset of scroll on tag list in mobile view
 * when the scroll is at the bottom, gradient will be disapeared
 */
  public onTagListScroll(event: Event) {
    const me = this;
    var element = (event.target as HTMLElement);
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      me.showGradient = false;
    } else {
      me.showGradient = true;
    }
    me.PushChanges();
  }

  public saveItemTags(event: MatCheckboxChange) {
    const me = this;
    if (me._userHelperService.IsRegistered) {
      me.saveToUserData = event.checked;
    } else {
      me.saveToUserData = false;
      me._bottomSheetHelperService.open(LoginDialogComponent);
    }
    me.PushChanges();
  }

}
